export default "__VITE_ASSET__BGCU1XGW__"